export enum STAGE {
  // eslint-disable-next-line @typescript-eslint/naming-convention
    Prod = 'Prod',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Test = 'Test',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Dev = 'Dev'
}
